/**
 * Returns an array with a single object to update the state of the RestartableController.svelte.
 * Use this method to avoid repeat the "[{}]" code.
 * @returns {Array}
 */
const restart_component = ()=> [{}];


export default restart_component;